
import { defineComponent, PropType, reactive } from 'vue'

import TheButton from '@/common/components/UI/TheButton/index.vue'
import useNotifications from '@/common/composable/useNotifications'

import { billing } from '@/core/realisations/billing.realisation'

export default defineComponent({
    components: {
        'the-button': TheButton,
    },
    props: {
        transcriptId: {
            type: Number,
            required: true,
        },
    },
    setup(props) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
        })

        const saveFile = (content: File | Blob, file_name: string) => {
            const download_url = window.URL.createObjectURL(content)

            const link = document.createElement('a')
            link.href = download_url
            link.setAttribute('download', file_name)
            document.body.appendChild(link)
            link.click()
            link.remove()
        }

        const downloadFile = async () => {
            try {
                state.is_loading = true

                const response = await billing.download1CFile(props.transcriptId)
                saveFile(response, 'Документы 1С')
            } catch (error) {
                notifications.notifyError({ error, title: 'При скачивании файла произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        return { state, downloadFile }
    },
})
